import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { BankingDetails, BasicCustomerDetails, ContactPersonDetails, TaxDetails } from '../../customerCreation/customerCreation';
import { useDispatch } from 'react-redux';
import { resetCustomerDetails } from '../../ReduxStore/actions';
import '../../customerCreation/customerCreation.css';
import { Typography, useMediaQuery } from '@mui/material';

const ProgressBar = ({ handleSubmit }) => {
    const [activeStep, setActiveStep] = React.useState(0);
    const [skipped, setSkipped] = React.useState(new Set());
    const [isStepValid, setIsStepValid] = React.useState(false);
    const dispatch = useDispatch();
    const isMobile = useMediaQuery('(max-width:600px)');
    const isStepSkipped = (step) => {
      return skipped.has(step);
    };
  
    const handleNext = () => {
      if (activeStep === steps.length - 1) {
        handleSubmit();
      } else {
        let newSkipped = skipped;
        if (isStepSkipped(activeStep)) {
          newSkipped = new Set(newSkipped.values());
          newSkipped.delete(activeStep);
        }
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setSkipped(newSkipped);
      }
    };
  
    const handleBack = () => {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
    const handleReset = () => {
      setActiveStep(0);
      dispatch(resetCustomerDetails());
    };
    const steps = ['Basic Customer Details', 'Contact person Details', 'Tax Details','Banking Details'];
    return (
      <Box sx={{ width: '100%' }}>
         {!isMobile && (
        <Stepper className='steperHeader' activeStep={activeStep}>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
      )}

      {isMobile && (
        <Typography variant="h6" align="center">
          {steps[activeStep]}
        </Typography>
      )}
        {activeStep === steps.length  ? (
          <React.Fragment>
            <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
              <Box sx={{ flex: '1 1 auto' }} />
              <Button onClick={handleReset}>Reset</Button>
            </Box>
          </React.Fragment>
        ) : (
          <React.Fragment>
            {/* <Typography sx={{ mt: 2, mb: 1 }}>Step {activeStep + 1}</Typography> */}
            {(activeStep + 1 === 1) && (
                <BasicCustomerDetails onValidationChange={setIsStepValid} />
            ) }
            {(activeStep + 1 === 2) && (
                <ContactPersonDetails onValidationChange={setIsStepValid}/>
            )}
            {(activeStep + 1 === 3) && (
                <TaxDetails onValidationChange={setIsStepValid}/>
            )}
            {(activeStep + 1 === 4) && (
                <BankingDetails onValidationChange={setIsStepValid}/>
            )}
            <div className='stepperButton'>
              <Button
                color="inherit"
                disabled={activeStep === 0}
                onClick={handleBack}
                sx={{ mr: 1 }}
              >
                <span><ArrowBackIosNewIcon className='stepperBackIcon'/></span>
                Back
              </Button>  
              <Button onClick={handleNext} disabled={!isStepValid}>
                {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                <span><ChevronRightIcon/></span>
              </Button>
              {/* <Button onClick={handleReset}>
                Reset
              </Button> */}
            </div>
          </React.Fragment>
        )}
      </Box>
  );
};

export default ProgressBar;